import amplitude from 'amplitude-js';

const API_KEY = process.env.VITE_APP_AMPLITUDE_KEY;

amplitude.getInstance().init(API_KEY!);

export { amplitude };
